// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceListGuestItem__list-item-ad077c {
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 8px 16px;
}

.SpaceListGuestItem__list-item-ad077c:hover,
.SpaceListGuestItem__list-item-ad077c:focus {
  background-color: var(--base-17);
}

.SpaceListGuestItem__avatar-d2994b {
  margin-inline-end: 12px;
}

.SpaceListGuestItem__info-f22646 {
  flex: 1;
  overflow: hidden;
}

.SpaceListGuestItem__name-wrapper-f97147 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.SpaceListGuestItem__name-fc440a {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.SpaceListGuestItem__members-a2aa52 {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SpacesList/SpaceListGuestItem/SpaceListGuestItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF","sourcesContent":[".list-item {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  padding: 8px 16px;\n}\n\n.list-item:hover,\n.list-item:focus {\n  background-color: var(--base-17);\n}\n\n.avatar {\n  margin-inline-end: 12px;\n}\n\n.info {\n  flex: 1;\n  overflow: hidden;\n}\n\n.name-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.name {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.members {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list-item": `SpaceListGuestItem__list-item-ad077c`,
	"listItem": `SpaceListGuestItem__list-item-ad077c`,
	"avatar": `SpaceListGuestItem__avatar-d2994b`,
	"info": `SpaceListGuestItem__info-f22646`,
	"name-wrapper": `SpaceListGuestItem__name-wrapper-f97147`,
	"nameWrapper": `SpaceListGuestItem__name-wrapper-f97147`,
	"name": `SpaceListGuestItem__name-fc440a`,
	"members": `SpaceListGuestItem__members-a2aa52`
};
module.exports = ___CSS_LOADER_EXPORT___;
